// extracted by mini-css-extract-plugin
module.exports = {"form-signin":"Login_form-signin__55x5M"};